<template>
  <SectionView :title="title" :tips="tips" @tip="tip" :titleIcon="require('@/assets/图标-检测项目.png')">
    <div :class="['table', {custom}]">
      <ul class="header">
        <li v-for="(value, key) in columns" :key="key">
          <template v-if="value.name">{{value.name}}</template>
          <template v-else>{{value}}</template>
        </li>
        <li class="menu" v-if="$slots.default || $scopedSlots.default">详情</li>
      </ul>

      <ul class="body" v-for="(row, index) in displayedList" :key="index">
        <li v-for="(value, key) in columns" :key="key">
          <template v-if="value.name">
            <div class="rich-text" v-html="value.value(row)"></div>
          </template>
          <template v-else>{{row[key]}}</template>
        </li>
        <li v-if="$slots.default || $scopedSlots.default">
          <slot v-bind="row"></slot>
        </li>
      </ul>
      
      <!-- <ul class="body more-row" v-if="list.length > 8" @click="toggleExpand">
        <li></li>
        <li class="more-cell">
          {{isExpanded ? '收起' : '查看更多项目'}}
        </li>
        <li class="arrow-cell">
          <a class="more-arrow" :style="{ transform: isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)' }"></a>
        </li>
      </ul> -->
    </div>

<!--    <ul class="header">
      <li v-for="(value, key) in columns" :key="key">
        <template v-if="value.name">{{value.name}}</template>
        <template v-else>{{value}}</template>
      </li>
      <li v-if="$slots.default || $scopedSlots.default">详情</li>
    </ul>

    <ul class="body" v-for="(row, index) in list" :key="index">
      <li v-for="(value, key) in columns" :key="key">
        <template v-if="value.name">
          <div class="rich-text" v-html="value.value(row)"></div>
        </template>
        <template v-else>{{row[key]}}</template>
      </li>
      <li v-if="$slots.default || $scopedSlots.default">
        <slot v-bind="row"></slot>
      </li>
    </ul>-->
  </SectionView>
</template>

<script>
  import SectionView from "@/components/SectionView";

  /**
   * 列表卡片
   */
  export default {
    name: "TableCard",
    components: {SectionView},

    props: {
      // 提示
      tips: {
        type: Boolean,
        default: false
      },
      // 标题
      title: {
        type: String,
        require: true
      },
      columns: {
        type: Object,
        require: true
      },
      // 内容
      list: {
        type: Array,
        require: true
      },
      // 自定义布局
      custom: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isExpanded: false
      }
    },

    computed: {
      displayedList() {
        // if (this.isExpanded || this.list.length <= 8) {
        //   return this.list;
        // } else {
        //   return this.list.slice(0, 8);
        // }
        return this.list;
      }
    },

    methods: {
      tip() {
        this.$emit('tip');
      },
      // toggleExpand() {
      //   this.isExpanded = !this.isExpanded;
      // }
    }
  }
</script>

<style lang="scss" scoped>
  /*ul {
    li {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &:first-child {
        padding-left: 20px;
        border-left: none;
        justify-content: flex-start;
      }
      &:last-child {
        padding-right: 20px;
      }
    }
  }

  .menu-table {
    ul {
      li {
        &:first-child {
          flex: none;
          width: 150px;
        }
        &:last-child {
          width: 80px;
        }
      }
    }
  }

  .header {
    height: 80px;
    background: #2262B1;
    border-radius: 10px;
    font-size: 32px;
    color: #FFFFFF;

    li {
      i {
        width: 30px;
        height: 30px;
        border-radius: 10px;
        margin-bottom: 10px;
      }

      span {
        line-height: 36px;
      }
    }

    .item {
      font-size: 30px;
      line-height: 36px;
    }
  }

  .body {
    height: 80px;
    background: #F5F6F9;
    border-radius: 10px;
    margin-top: 10px;

    &:nth-child(2n) {
      background: #E0EDFF;
    }

    li {
      height: 100%;
      font-size: 32px;
      color: #333333;

      img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        margin: 0 10px 0 12px;
      }

      i {
        width: 30px;
        height: 30px;
        border-radius: 10px;
        margin: 0 auto;
      }

      ::v-deep a {
        display: block;
        text-decoration: none;
        width: 40px;
        height: 40px;
        border-radius: 0;
        background: url("../assets/more.png") no-repeat;
        background-size: 40px 40px;
      }

      .rich-text {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 110px;
        flex-wrap: nowrap;
        flex-shrink: 0;
      }
    }
  }*/

  .table {
    display: table;
    border-collapse: separate;
    border-spacing: 0 10px;
    width: 100%;

    ul {
      display: table-row;
      height: 80px;

      li {
        border-top: 1px solid #C9D8F4; /* Changed border color */
        border-bottom: 1px solid #C9D8F4; /* Changed border color */
        display: table-cell;
        vertical-align: middle;
        text-align: right;
        padding-right: 5px;

        &:first-child {
          border-left: 1px solid #C9D8F4; /* Changed border color */
          border-radius: 10px 0 0 10px;
          padding-left: 20px;
          text-align: left;
          padding-right: 0;
        }
        &:last-child {
          border-right: 1px solid #C9D8F4; /* Changed border color */
          border-radius: 0 10px 10px 0;
          padding-right: 20px;
        }
        &.menu {
          width: 80px;
        }
      }
    }

    &.custom {
      ul {
        li {
          padding-right: 60px;
          
          &:first-child {
            padding-left: 60px;
            padding-right: 0;            
          }
          &:last-child {
            padding-right: 50px;
          }
          &.menu {
            width: auto;
          }
        }
      }
    }
  }

  .header {
    background: #4E7FDC;
    font-size: 26px;
    font-weight: 600;
    color: #FFFFFF;
    /* border: 1px solid black; Removed border from row */
}
  /* 更具体地选中 table.custom 下的 ul.header 下的 li */
.table.custom ul.header li {
  padding-right: 20px;

  &:first-child {
  padding-left: 60px;
  padding-right: 0;            
  }
  &:last-child {
  padding-right: 50px;
  }
  &.menu {
  width: auto;
    }
  }

.body {
    background: #F5F6F9;
    font-size: 30px;
    color: #333333;
    /* border: 1px solid black; Removed border from row */

    &:nth-child(2n) {
      background: #E0EDFF;
    }
    
    &.more-row {
      background: #E6F0FF;
      cursor: pointer;
      
      li:first-child {
        width: 33%;
      }
      
      .more-cell {
        width: 34%;
        text-align: center;
        color: black; /* Changed color to black */
        padding-left: 0;
        padding-right: 0;
        font-size: 28px;
        font-weight: 470;
      }
      
      .arrow-cell {
        width: 33%;
        text-align: right;
        padding-left: 0;
        padding-right: 20px;
        
        .more-arrow {
          display: inline-block;
          width: 40px;
          height: 40px;
          border-radius: 0;
          background: url("../assets/more.png") no-repeat;
          background-size: 40px 40px;
        }
      }
    }

    ::v-deep a {
      display: block;
      text-decoration: none;
      width: 40px;
      height: 40px;
      border-radius: 0;
      background: url("../assets/more.png") no-repeat;
      background-size: 40px 40px;
      float: right;
      margin-right: 0;
    }

    .rich-text {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-wrap: nowrap;
      flex-shrink: 0;
    }

    // Apply AccidentalPresidency font to the second column (assuming it contains numbers)
    li:nth-child(2) {
      font-size: 38px;
      font-family: AccidentalPresidency;
    }
  }
</style>
